/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IFilterOption {
  /** Название опции на английском **/
  name: EName;
  /** Название опции на русском(для вывода на клиент) **/
  displayName: string;
  /** Путь к иконке, иллюстрирующей опцию фильтра **/
  iconUrl?: TFilterOption_IconUrl;
}

export enum EName {
  /** Без ремонта **/
  'RepairTypeWithout' = 'repairTypeWithout',
  /** Косметический ремонт **/
  'RepairTypeCosmetic' = 'repairTypeCosmetic',
  /** Евроремонт **/
  'RepairTypeEuro' = 'repairTypeEuro',
  /** Дизайнерский ремонт **/
  'RepairTypeDesign' = 'repairTypeDesign',
  /** 1 год ремонту **/
  'RepairAgeOne' = 'repairAgeOne',
  /** 2 года ремонту **/
  'RepairAgeTwo' = 'repairAgeTwo',
  /** 3 года ремонту **/
  'RepairAgeThree' = 'repairAgeThree',
  /** 4 года ремонту **/
  'RepairAgeFour' = 'repairAgeFour',
  /** Больше 5 лет ремонту **/
  'RepairAgeMoreThanFive' = 'repairAgeMoreThanFive',
  /** 1 этаж **/
  'FloorOne' = 'floorOne',
  /** 2 этаж **/
  'FloorTwo' = 'floorTwo',
  /** Последний этаж **/
  'FloorLast' = 'floorLast',
  /** Другой этаж **/
  'FloorOther' = 'floorOther',
  /** Парадная после ремонта **/
  'EntranceAfterRepair' = 'entranceAfterRepair',
  /** Есть консьерж в парадной **/
  'EntranceConcierge' = 'entranceConcierge',
  /** Кухонная мебель **/
  'KitchenFurniture' = 'kitchenFurniture',
  /** Стиральная машина **/
  'WashingMachine' = 'washingMachine',
  /** Телевизор **/
  'Tv' = 'tv',
  /** Холодильник **/
  'Fridge' = 'fridge',
  /** Кондиционер **/
  'Conditioner' = 'conditioner',
  /** Можно с детьми **/
  'ChildrenAllowed' = 'childrenAllowed',
  /** Можно с животными **/
  'PetsAllowed' = 'petsAllowed',
  /** Кирпичный дом **/
  'WallMaterialBrick' = 'wallMaterialBrick',
  /** Монолитный дом **/
  'WallMaterialMonolith' = 'wallMaterialMonolith',
  /** Панельный дом **/
  'WallMaterialPanel' = 'wallMaterialPanel',
  /** Деревянный дом **/
  'WallMaterialWood' = 'wallMaterialWood',
  /** Блочный дом **/
  'WallMaterialBlock' = 'wallMaterialBlock',
  /** Кирпично-монолитный дом **/
  'WallMaterialMonolithBrick' = 'wallMaterialMonolithBrick',
  /** Один этаж в доме **/
  'FloorCountOne' = 'floorCountOne',
  /** Два этажа в доме **/
  'FloorCountTwo' = 'floorCountTwo',
  /** Три этажа в доме **/
  'FloorCountThree' = 'floorCountThree',
  /** Четыре и больше этажей в доме **/
  'FloorCountFourPlus' = 'floorCountFourPlus',
  /** Год постройки до 2000 года **/
  'BuildYearBefore2000' = 'buildYearBefore2000',
  /** Год постройки c 2000-2009 года **/
  'BuildYearFrom2000To2009' = 'buildYearFrom2000To2009',
  /** Год постройки с 2009-2019 года **/
  'BuildYearFrom2009To2019' = 'buildYearFrom2009To2019',
  /** Год постройки с 2020 года **/
  'BuildYearFrom2020' = 'buildYearFrom2020',
  /** Санузел в доме **/
  'WcTypeLocationIndoor' = 'wcTypeLocationIndoor',
  /** Санузел на улице **/
  'WcTypeLocationOutdoor' = 'wcTypeLocationOutdoor',
  /** Гараж **/
  'Garage' = 'garage',
  /** Терраса **/
  'Terrace' = 'terrace',
  /** Погреб **/
  'Cellar' = 'cellar',
  /** Бассейн **/
  'Pool' = 'pool',
  /** Баня **/
  'Bathhouse' = 'bathhouse',
  /** Охрана **/
  'Security' = 'security',
}
export type TFilterOption_IconUrl = null | string;
